import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class NotificationPreferenceService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getMyPreferences() {
        try {
            return await withRetry(
                () => this.api.getMyPreferences(),
                { maxRetries: 2 },
            );
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch notification preferences');
        }
    }

    async updateMyPreferences(data) {
        try {
            return await this.api.updateMyPreferences(data);
        } catch (error) {
            throw this._handleError(error, 'Failed to update notification preferences');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) {
            throw error;
        }
        if (error.statusCode || error.status) {
            throw ApiError.fromResponse(error);
        }
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
